function treatImage(imageUrl = '', treatment) {
  return treatment ? imageUrl.replace('TREATMENT', treatment) : imageUrl;
}

module.exports = {
  treatImage
};
